/* Pet Nugget selling-plan helpers.
 *
 * Appstle creates standard Shopify selling plans. These helpers deliberately
 * depend only on the selling-plan data emitted by snippets/product-json.liquid,
 * so the theme never needs Appstle-specific DOM hooks or duplicated plan IDs.
 */
(function (root, factory) {
  var helpers = factory();
  if (typeof module === 'object' && module.exports) module.exports = helpers;
  if (root) root.PNPlanUtils = helpers;
})(typeof window !== 'undefined' ? window : this, function () {
  'use strict';

  var UNIT_DAYS = { day: 1, week: 7, month: 30, year: 365 };

  function text(value) { return value == null ? '' : String(value); }

  function durations(value) {
    var matches = [];
    var re = /(\d+(?:\.\d+)?)\s*[- ]?\s*(day|week|month|year)s?/gi;
    var match;
    value = text(value);
    while ((match = re.exec(value))) {
      matches.push(Math.round(parseFloat(match[1]) * UNIT_DAYS[match[2].toLowerCase()]));
    }
    return matches;
  }

  function optionText(plan) {
    var result = '';
    try {
      (plan && plan.options || []).forEach(function (option) {
        if (typeof option === 'string') result += ' ' + option;
        else result += ' ' + text(option && option.name) + ' ' + text(option && option.value);
      });
    } catch (e) {}
    return result;
  }

  function planDays(plan) {
    if (!plan) return null;
    var fromOptions = durations(optionText(plan));
    if (fromOptions.length) return fromOptions[0];
    var fromName = durations(plan.name);
    if (fromName.length) return fromName[0];
    var fromDescription = durations(plan.description);
    return fromDescription.length ? fromDescription[0] : null;
  }

  function supplyDays(plan) {
    if (!plan) return null;
    var match = text(plan.name).match(/(\d+)\s*[- ]?\s*day\s+supply/i);
    if (match) return parseInt(match[1], 10);
    return planDays(plan);
  }

  function findPlan(product, targetDays, targetDiscount, basePrice) {
    var plans = product && product.sellingPlans || [];
    var matches = [];
    var i;
    for (i = 0; i < plans.length; i++) {
      if (supplyDays(plans[i]) === targetDays) matches.push(plans[i]);
    }
    if (!matches.length) {
      for (i = 0; i < plans.length; i++) {
        if (planDays(plans[i]) === targetDays) matches.push(plans[i]);
      }
    }
    if (targetDiscount == null) return matches[0] || null;
    for (i = 0; i < matches.length; i++) {
      if (Math.abs(discountPercent(matches[i], basePrice) - Number(targetDiscount)) < 0.05) return matches[i];
    }
    return null;
  }

  function discountPercent(plan, basePrice) {
    if (!plan) return 0;
    var explicit = Number(plan.discountPercent);
    if (isFinite(explicit) && explicit > 0) return explicit;
    var copy = text(plan.name) + ' ' + text(plan.description);
    var match = copy.match(/(\d+(?:\.\d+)?)\s*%/);
    if (match) return parseFloat(match[1]);
    var planPrice = Number(plan.price);
    basePrice = Number(basePrice);
    if (!basePrice || !isFinite(planPrice)) return 0;
    return Math.round(((basePrice - planPrice) / basePrice) * 10000) / 100;
  }

  function formatPercent(value) {
    value = Math.round(Number(value || 0) * 100) / 100;
    return value.toFixed(2).replace(/\.?0+$/, '') + '%';
  }

  return {
    discountPercent: discountPercent,
    findPlan: findPlan,
    formatPercent: formatPercent,
    planDays: planDays,
    supplyDays: supplyDays
  };
});
